import { axios } from '@/utils/request'

/**
 * 查询列表
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function numSourceDetailPage (parameter) {
  return axios({
    url: '/buregresource/page',
    method: 'post',
    data: parameter
  })
}

/**
 * 查询未生效列表
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function getDoctorServicesPage (parameter) {
  return axios({
    url: '/userBasic/getDoctorServices',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑未生效列表
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function updateDoctorService (parameter) {
  return axios({
    url: '/userBasic/updateDoctorService',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除未生效列表
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function deleteDoctorService (parameter) {
  return axios({
    url: '/userBasic/deleteDoctorService',
    method: 'post',
    data: parameter
  })
}

/**
 * 停用
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function Deactivate (parameter) {
  return axios({
    url: '/buregresource/manage',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientAdd (parameter) {
  return axios({
    url: '/baPatient/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baSourceEdit (parameter) {
  return axios({
    url: '/buregresource/updateMount',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientDelete (parameter) {
  return axios({
    url: '/baPatient/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出就诊人查询
 *
 * @author liwei
 * @date 2022-04-16 15:20:16
 */
export function baPatientExport (parameter) {
  return axios({
    url: '/baPatient/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
